import z from 'zod';

const $jwtConfig = z.object({
  type: z.literal('jwt'),
  issuer: z.string(),
  algorithm: z.string(),
  secret: z.string(),
});

export type JwtConfig = z.infer<typeof $jwtConfig>;

const $jwksConfig = z.object({
  type: z.literal('jwks'),
  issuer: z.string(),
  endpoint: z.string(),
});

export type JwksConfig = z.infer<typeof $jwksConfig>;

export const $jwtConfigItem = z.union([$jwtConfig, $jwksConfig]);

export const $secureTokenOptionsSchema = z.object({
  identityKind: z.string(),
  algorithms: z.array($jwtConfigItem).min(1),
});

export type SecureTokenOptions = z.infer<typeof $secureTokenOptionsSchema>;
export type JwtConfigItem = z.infer<typeof $jwtConfigItem>;
